module.exports = __webpack_public_path__ + "static/media/filled_bar_preinspect_tall.cdbf5b6a.svg";